module.exports = __webpack_public_path__ + "img/receipt-cutoff.c862e306.svg";